// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.0-beta.45b0757e1',
  revision: '45b0757e1',
  branch: 'develop',
  date: 'Fri, 13 Mar 2026 16:14:42 GMT'
};